<div class="wrapper">
    <google-chart *qmLoading="loading;config:loadingConfig" [type]="'OrgChart'" [data]="myDeps" [columnNames]="columnNames"
                  [options]="options" (select)="handleChartSelect($event)"></google-chart>
</div>
